import { useState } from 'react'
import PropTypes from 'prop-types'
import { HeaderTitle } from '../../../../common/HeaderTitle.jsx'
import { ListaElementyRejestru } from '../../lib/parts/ListaElementyRejestru.jsx'
import { ListFilterTabs } from '../../lib/components/ListFilterTabs.jsx'
import { useListaElementow } from '../../../../../api/domain/elementyRejstru/queries/useListaElementow.jsx'

const ViewListaElementyRejestru = (props) => {
    const titleName = 'Lista projektów'
    const [activeTab, setActiveTab] = useState('aktywne')

    const listaPozycji = useListaElementow('', true, activeTab)

    const handleTabChange = (tab) => {
        setActiveTab(tab)
    }

    const getExportFileName = () => {
        if (props.moje) return 'moje_wszystkie_projekty'
        switch (activeTab) {
            case 'archiwum': return 'projekty_archiwum'
            case 'prosby': return 'projekty_prosby'
            case 'wszystkie': return 'projekty_wszystkie'
            default: return 'projekty_aktywne'
        }
    }

    return (
        <>
            <HeaderTitle
                breadcrumbLinks={[{ label: titleName }]}
                home
                nav
                destination={'/'}
                size={'fs-3'}
                title={titleName}
            />
            
            <ListFilterTabs
                activeTab={activeTab}
                onTabChange={handleTabChange}
                counts={listaPozycji.data?.counts || {}}
            />
            
            <ListaElementyRejestru
                key={activeTab}
                exportFileName={getExportFileName()}
                listaPozycji={listaPozycji}
                filterType={activeTab}
            />
        </>
    )
}

ViewListaElementyRejestru.propTypes = {
    moje: PropTypes.bool,
}

export default ViewListaElementyRejestru
